<template lang="pug">
    .account__settings(v-loading="loading")
        .account__title
            h2 Account Settings
        form.form(autocomplete="off" @submit.prevent="saveProfile" v-loading="saving")
            input(type="text" autoComplete="off" style="display: none;" aria-label="Hidden input")
            form.common-form
                .form-group
                    h3 Contact Information
                    .row
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="email_input") Email Address
                                input(type="email" name="email"
                                    id="email_input"
                                    v-model="user.email"
                                    v-validate="'required|email'"
                                    data-vv-as="Email Address"
                                    data-vv-name="email"
                                    v-bind=`{
                                        "aria-describedby": errors.collect('email').length ? 'email_error' : false,
                                    }`
                                )
                                span#email_error.validation-errors(v-for="error in errors.collect('email')") {{ error }}
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="phone_input") Phone
                                input(type="tel" name="phone"
                                    id="phone_input"
                                    v-model="customer.phone"
                                    v-validate="'required'"
                                    data-vv-as="Phone"
                                    data-vv-name="phone"
                                    v-bind=`{
                                        "aria-describedby": errors.collect('phone').length ? 'phone_error' : false,
                                    }`
                                )
                                span#phone_error.validation-errors(v-for="error in errors.collect('phone')") {{ error }}
                    .row
                        .col-lg-12.col-sm-12.col-xs-12
                            .form-group
                                .checkbox-group.mb-0
                                    input(
                                        type="checkbox"
                                        name="is-promotionable"
                                        id="is-promotionable"
                                        v-model="customer.is_promotionable"
                                    )
                                    label(for="is-promotionable" tabindex=0) I want to receive emails about promotions and products
                                    span.validation-errors(v-if="optOutPromotionsText && !customer.is_promotionable") {{ optOutPromotionsText }}
                        .col-lg-12.col-sm-12.col-xs-12(v-if="gdprLink")
                            .form-group
                                .checkbox-group
                                    input(
                                        type="checkbox"
                                        name="is-gdpr-accepted"
                                        id="is-gdpr-accepted"
                                        v-model="customer.is_agreement_accepted"
                                    )
                                    label(for="is-gdpr-accepted")
                                        span I have read and agree to &nbsp;
                                            a(:href="gdprLink", @click.prevent="openGdpr()") the Privacy Policy
                    .row
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="first_name_input") First Name
                                input(type="text"
                                    id="first_name_input"
                                    v-model="customer.first_name"
                                    v-validate="'required'"
                                    data-vv-as="First Name"
                                    data-vv-name="first_name"
                                    v-bind=`{
                                        "aria-describedby": errors.collect('first_name').length ? 'first_name_error' : false,
                                    }`
                                )
                                span#first_name_error.validation-errors(v-for="error in errors.collect('first_name')") {{ error }}
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="last_name_input") Last Name
                                input(type="text"
                                    id="last_name_input"
                                    v-model="customer.last_name"
                                    v-validate="'required'"
                                    data-vv-as="Last Name"
                                    data-vv-name="last_name"
                                    v-bind=`{
                                        "aria-describedby": errors.collect('last_name').length ? 'last_name_error' : false,
                                    }`
                                )
                                span#last_name_error.validation-errors(v-for="error in errors.collect('last_name')") {{ error }}
                    .row
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="birthday_input") Birthday
                                el-date-picker(
                                    id="birthday_input"
                                    v-model="birthday"
                                    :picker-options=`{
                                        disabledDate: isDateDisabled,
                                    }`
                                    @change="setBirthday"
                                    placeholder="Example: 20 Apr 1980"
                                    format="dd MMM yyyy"
                                    value-format="yyyy-MM-dd"
                                )
                .form-group
                    h3 Shipping Address
                    .row
                        .col-lg-12.col-sm-12.col-xs-12
                            .form-control
                                label.form-label(for="company_input") Company
                                input(type="text" v-model="address.company" id="company_input")
                    .row
                        .col-lg-12.col-sm-12.col-xs-12
                            .form-control
                                label.form-label(for="address_line_1_input") Address Line 1
                                input(type="text"
                                    id="address_line_1_input"
                                    v-model="address.address_line_1"
                                    v-validate="'required'"
                                    data-vv-as="Address Line 1"
                                    data-vv-name="address_line_1"
                                    v-bind=`{
                                        "aria-describedby": errors.collect('address_line_1').length ? 'address_line_1_error' : false,
                                    }`
                                )
                                span#address_line_1_error.validation-errors(v-for="error in errors.collect('address_line_1')") {{ error }}
                    .row
                        .col-lg-12.col-sm-12.col-xs-12
                            .form-control
                                label.form-label(for="address_line_2_input") Address Line 2
                                input(type="text"
                                    id="address_line_2_input"
                                    v-model="address.address_line_2"
                                )
                    .row
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="city_input") City
                                input(type="text"
                                    id="city_input"
                                    v-model="address.city"
                                    v-validate="'required'"
                                    data-vv-as="City"
                                    data-vv-name="city"
                                    v-bind=`{
                                        "aria-describedby": errors.collect('city').length ? 'city_error' : false,
                                    }`
                                )
                                span#city_error.validation-errors(v-for="error in errors.collect('city')") {{ error }}
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="zip_code_input") ZIP Code
                                input(type="text"
                                    id="zip_code_input"
                                    v-model="address.zip_code"
                                    v-validate="'required'"
                                    data-vv-as="ZIP Code"
                                    data-vv-name="zip_code"
                                    v-bind=`{
                                        "aria-describedby": errors.collect('zip_code').length ? 'zip_code_error' : false,
                                    }`
                                )
                                span#zip_code_error.validation-errors(v-for="error in errors.collect('zip_code')") {{ error }}
                    .row
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="countries_input") Countries
                                v-select(
                                    :options="countries"
                                    title="Countries"
                                    label="title"
                                    placeholder="Select Country"
                                    v-if="countries && !loading"
                                    :reduce="country => country.code"
                                    :readonly="loading"
                                    required
                                    v-validate="'required'"
                                    data-vv-as="Country"
                                    data-vv-name="country"
                                    :value="address.country"
                                    @input="setCountry"
                                    input-id="countries_input"
                                    id="country_select"
                                    :aria-label="countryAriaLabel"
                                )
                                    template(#search="{ attributes, events }")
                                        input(
                                            class="vs__search"
                                            v-bind="attributes"
                                            v-on="events"
                                            aria-labelledby="country_select"
                                        )
                                span.validation-errors(v-for="error in errors.collect('country')") {{ error }}
                        .col-lg-6.col-sm-6.col-xs-12
                            .form-control
                                label.form-label(for="states_input") States
                                v-select(
                                    :options="states" title="States" label="title"
                                    placeholder="States"
                                    :reduce="state => state.code"
                                    :disabled="loading || !isStatesExists"
                                    v-if="states && !loading && !loadingStates"
                                    autocomplete="off-disabled"
                                    v-validate="isStatesExists ? 'required' : ''"
                                    data-vv-as="State"
                                    data-vv-name="state"
                                    :value="address.state"
                                    @input="setState"
                                    input-id="states_input"
                                    id="states_select"
                                    :aria-label="stateAriaLabel"
                                )
                                    template(#search="{ attributes, events }")
                                        input(
                                            class="vs__search"
                                            v-bind="attributes"
                                            v-on="events"
                                            aria-labelledby="states_select"
                                        )
                                span.validation-errors(v-for="error in errors.collect('state')") {{ error }}
                button.btn.btn-default(@click.prevent="saveProfile" :disabled="saving") Save
</template>

<script>
    import countryStateMixin from '@mixins/countryStateMixin';
    import moment from 'moment';

    import {has as isHas} from 'lodash';

    export default {
        mixins: [countryStateMixin],
        props: {
            optOutPromotionsText: {
                type: String,
                default: null
            },
            gdprLabel: {
                type: String,
                default: null
            },
            gdprLink: {
                type: String,
                default: null
            }
        },
        computed: {
            stateAriaLabel() {
                const {states, selectedState} = this;
                if (selectedState && states.length) {
                    const stateObj = states.filter(e => e.code === selectedState)[0];

                    if (stateObj && stateObj.title) {
                        return 'Search for states. Selected state: ' + stateObj.title;
                    }
                }

                return 'Search for states.';
            },
            countryAriaLabel() {
                const {countries, selectedCountry} = this;
                if (selectedCountry && countries.length) {
                    const stateObj = countries.filter(e => e.code === selectedCountry)[0];

                    if (stateObj && stateObj.title) {
                        return 'Search for countries. Selected country: ' + stateObj.title;
                    }
                }

                return 'Search for countries.';
            },
            loading: function () {
                return this.loadingProfile || this.loadingCountries;
            },
            isStatesExists: function () {
                return this.states && this.states.length > 0;
            },
            disabledDates() {
                return {
                    from: new Date()
                }
            }
        },
        data: function () {
            return {
                //states
                loadingProfile: false,
                saving: false,

                //forms
                user: {
                    email: null,
                },
                customer: {
                    phone: null,
                    first_name: null,
                    last_name: null,
                    is_promotionable: true,
                    birthday_date: null
                },
                address: {
                    company: null,
                    address_line_1: null,
                    address_line_2: null,
                    city: null,
                    country: null,
                    state: null,
                },
                useUtc: true,
                birthday: null
            }
        },
        mounted: function () {
            this.loadCountries();
            this.loadProfile();
        },
        watch: {
            selectedCountry: function (value) {
                this.address.country = value;
            },
            selectedState: function (value) {
                this.address.state = value;
            },
        },
        methods: {
            isDateDisabled(date) {
                return date > new Date();
            },
            loadProfile: function () {
                this.loadingProfile = true;

                axios.get('/api/v1/account/profile')
                    .then(r => {
                        const profileData = r.data.data;
                        this.user.email = profileData.email;
                        if (profileData.customer.data) {
                            const customerData = profileData.customer.data;
                            this.customer = {
                                phone: customerData.phone,
                                first_name: customerData.first_name,
                                last_name: customerData.last_name,
                                is_promotionable: customerData.is_promotionable || true,
                                is_agreement_accepted: customerData.is_agreement_accepted || false
                            };

                            this.birthday = customerData.birthday_date ? moment.utc(customerData.birthday_date).toDate() : null;

                            if (customerData.defaultShippingAddress.data) {
                                const address = customerData.defaultShippingAddress.data;

                                this.address = {
                                    company: address.company,
                                    address_line_1: address.address_line_1,
                                    address_line_2: address.address_line_2,
                                    city: address.city,
                                    zip_code: address.zip_code,
                                    country: address.country,
                                    state: address.state,
                                };
                                this.setCountry(address.country);
                                this.setState(address.state);
                            }
                        }

                        if (isHas(profileData, 'geo_data.state') && !this.address.country) {
                            this.setCountry(profileData.geo_data.iso_code);
                            this.setState(profileData.geo_data.state);
                        }

                        if (!this.address.city && isHas(profileData.geo_data.city)) {
                            this.address.city = profileData.geo_data.city;
                        }
                    })
                    .catch(e => {

                    })
                    .then(() => {
                        this.loadingProfile = false;
                    });
            },
            setCountry: function (value) {
                this.selectedCountry = this.address.country = value;
                this.selectedState = this.address.state = null;
                this.loadStates();
            },
            setState: function (value) {
                this.selectedState = this.address.state = value;
            },
            setBirthday: function (date) {
                this.customer.birthday_date = moment.utc(date).format()
            },
            saveProfile: function () {
                this.$validator
                    .validate()
                    .then(valid => {
                        if (!valid) {
                            const first_error = this.$validator.errors.items[0].field;

                            if (first_error) {
                                this.$scrollTo(`[data-vv-name="${first_error}"]`);
                            }
                            return;
                        }

                        this.saving = true;

                        let form = {
                            user: this.user,
                            customer: this.customer,
                            address: this.address,
                        };

                        axios.post('/api/v1/account/profile', form)
                            .then((r) => {
                                this.$message(r.data);
                                this.loadProfile();
                            })
                            .catch((e) => {
                                this.$handleError(e)
                            })
                            .finally(() => {
                                this.saving = false;
                            });
                    });
            },
            openGdpr: function () {
                window.open(this.gdprLink);
            }
        }
    };
</script>
